import * as zod from 'zod';

import { CameraIntegration } from '@sb/integrations/types/cameraTypes';

import { Expression } from '../../types';
import { RegionOfInterest } from '../../vision/VisionInterface';

export default zod.object({
  camera: CameraIntegration.optional(),
  // Optional equipment ID for camera-bot-cpp mode (when set, camera field is ignored)
  cameraEquipmentId: zod.string().optional(),
  regionOfInterest: RegionOfInterest.optional(),
  saveEquipmentId: zod.string(),
  saveFilepath: Expression,
});
